import { FaFileContract } from "react-icons/fa";
import { StructureBuilder, StructureResolverContext } from "sanity/structure";

export default (S: StructureBuilder, context: StructureResolverContext) =>
  S.listItem()
    .title("Terms And Conditions")
    .icon(FaFileContract)
    .child(
      S.list()
        .title("Terms And Conditions")
        .items([
          S.documentListItem()
            .schemaType(`offersTermsAndConditions`)
            .icon(FaFileContract)
            .id(`offersTermsAndConditions-termsAndConditions`)
            .title(`Offers General Page`)
        ])
    );
